/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { MenuOutlined } from '@ant-design/icons';
import { Dropdown, Layout, Menu } from 'antd';
import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useEffect, useRef, useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import avatarIc from '../../../assets/icons/avatar.svg';
import { EMITTER_CONSTANTS } from '../../../constants';
import { logoutRequest } from '../../../redux/actions/login';
import auth from '../../../utils/auth';
import { useEmitter } from '../../../utils/hooks';
import './style.scss';

const { Header } = Layout;

const routes = [
  {
    label: 'Reassign eID history',
    ref: '/reassign-eid',
  },
  {
    label: 'Card\'s license and status',
    ref: '/card-license',
  },
  {
    label: 'User management',
    ref: '/user-management',
  },
  {
    label: 'Customer accounts',
    ref: '/customer-accounts',
  },
  {
    label: 'Card\'s information',
    ref: '/card-information',
  },
  {
    label: 'Add new cards',
    ref: '/add-new-card',
  },
  {
    label: 'User\'s profile',
    ref: '/user-info',
  },
  {
    label: 'My profile',
    ref: '/my-profile',
  },
];

const MainHeader = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const [title, setTitle] = useState();
  const [userName, setUserName] = useState(auth.getLoginData().fullName);

  const onSignoutClick = () => {
    dispatch(logoutRequest());
    history.push('/login');
  };

  const onMyAccountClick = () => {
    if (!history.location.pathname.includes('/my-profile')) {
      history.push('/my-profile');
    }
  };

  const onUpdateProfile = () => {
    setUserName(auth.getLoginData().fullName);
  };

  useEffect(() => {
    const currentRoute = _.find(routes, x => location.pathname.includes(x.ref));
    if (currentRoute) {
      setTitle(currentRoute.label);
    }
  }, [location.pathname]);

  useEmitter(EMITTER_CONSTANTS.TOKEN_EXPIRED, onSignoutClick, []);
  useEmitter(EMITTER_CONSTANTS.UPDATE_PROFILE, onUpdateProfile, []);

  const menuRef = useRef((
    <Menu>
      <Menu.Item key="0">
        <button
          className="main-header-btn dropdown"
          onClick={onMyAccountClick}
        >
          My account
        </button>
      </Menu.Item>
      <Menu.Item key="1">
        <button
          className="main-header-btn dropdown"
          onClick={onSignoutClick}
        >
          Sign out
        </button>
      </Menu.Item>
    </Menu>
  ));

  return (
    <Header className={classnames('main-header', props.className)}>
      <div className="flex">
        <button
          className="main-header-btn mr-16"
          onClick={props.onToggleMenu}
        >
          {props.icon}
        </button>
        <h1 className="main-header-title">{title}</h1>
      </div>
      <div className="avatar flex gap-24">
        <div className="flex gap-12">
          <Dropdown overlayClassName="profile-dropdown" overlay={menuRef.current} trigger={['click']}>
            <img src={avatarIc} alt="" />
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

MainHeader.defaultProps = {
  className: '',
  icon: <MenuOutlined />,
  onToggleMenu: () => { },
};
MainHeader.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node,
  onToggleMenu: PropTypes.func,
};

export default MainHeader;
